module.exports = __webpack_public_path__ + "img/influence_man.55839589.svg";